import { Component, Input, OnInit } from '@angular/core';
import { Offer } from '../../../models/Offer';
import { BaseHttpService } from 'src/app/services/base-http/base-http.service';
import { Router } from '@angular/router';
import { OffersService } from '../../../services/offers/offers.service';
import { LanguageService } from '../../../services/languages/language.service';
import { NavBarService } from '../../../services/nav-bar/nav-bar.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-offer-slider',
  templateUrl: './offer-slider.component.html',
  styleUrls: ['./offer-slider.component.scss'],
  animations: [
    trigger('hovered', [
      state(
        'show',
        style({
          opacity: 1,
        })
      ),
      state(
        'hide',
        style({
          opacity: 0,
        })
      ),
      transition('show => hide', [animate('0.3s ease-out')]),
      transition('hide => show', [animate('0.3s ease-out')]),
    ]),
  ],
})
export class OfferSliderComponent implements OnInit {
  @Input() title: string;
  @Input() offers: Offer[];
  mainSliderOfferRequestSent: boolean;

  selectedOfferIndex: number;
  canClickArrowLeft: boolean;
  canClickArrowRight: boolean;

  autoScrollInterval: number;
  languageKey: string;

  hovered: boolean;

  constructor(
    public httpService: BaseHttpService,
    public router: Router,
    public offersService: OffersService,
    private languageService: LanguageService,
    private navService: NavBarService
  ) {
    this.selectedOfferIndex = 0;
    this.offers = [];
    this.mainSliderOfferRequestSent = false;
    this.languageService.currentLanguageKey.subscribe((val) => {
      this.languageKey = val;
    });
  }

  ngOnInit() {
    this.updateArrows();
    this.resetAutoScrollInterval();
  }

  private updateArrows() {
    this.canClickArrowLeft = this.selectedOfferIndex > 0;
    this.canClickArrowRight = this.selectedOfferIndex < this.offers.length - 1;
  }

  resetAutoScrollInterval() {
    clearInterval(this.autoScrollInterval);
    this.autoScrollInterval = setInterval(() => {
      this.selectedOfferIndex =
        this.selectedOfferIndex < this.offers.length - 1
          ? this.selectedOfferIndex + 1
          : 0;
      this.updateArrows();
    }, 5000) as any;
  }

  clickOnSeeMore(offer: Offer): void {
    this.router.navigate([this.languageKey + '/offer/' + offer.id.toString()]);
  }

  clickArrowLeft(): void {
    if (this.canClickArrowLeft) {
      this.selectedOfferIndex--;
      this.resetAutoScrollInterval();
      this.updateArrows();
    } else {
      this.clickCircle(this.offers.length - 1);
    }
  }

  clickArrowRight(): void {
    if (this.canClickArrowRight) {
      this.selectedOfferIndex++;
      this.resetAutoScrollInterval();
      this.updateArrows();
    } else {
      this.clickCircle(0);
    }
  }

  clickCircle(circleIndex: number): void {
    this.selectedOfferIndex = circleIndex;
    this.resetAutoScrollInterval();
    this.updateArrows();
  }

  redirect() {
    if (this.title === 'SALES') {
      this.navService.salesClicked();
    } else {
      this.navService.rentsClicked();
    }
  }

  get translatePosition(): number {
    return -(this.selectedOfferIndex / this.offers.length) * 100;
  }

  getContainerStyle() {
    const style = {};
    style['transform'] = 'translateX(' + this.translatePosition + '%)';
    style['width'] = this.offers.length * 100 + '%';
    return style;
  }
}
